import type { Ref } from '@vue/composition-api';
import { ref } from '@vue/composition-api';
import { defineStore } from 'pinia';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { Channel } from '@getaccept/pusher';
import { useToast } from '@getaccept/lib-shared/src/toast';
import type { User } from '../types/user';
import { UserService } from '../../api/users/services/user.service';

export const useUserStore = defineStore('user', () => {
  const { toast } = useToast();
  const user: Ref<User> = ref(null);
  const loading = ref(false);
  const loaded = ref(false);
  const error = ref(false);
  const pusherChannel: Ref<Channel> = ref(null);

  const fetchUser = async () => {
    loaded.value = false;
    loading.value = false;
    error.value = false;
    try {
      user.value = await UserService.loadCurrentUser();
      loaded.value = true;
    } catch {
      toast.danger(t('failed-to-fetch-user'));
      console.error('Could not load user');
      error.value = true;
    } finally {
      loading.value = false;
    }
  };

  return {
    user,
    loading,
    loaded,
    pusherChannel,
    fetchUser,
    error,
  };
});
